import { api } from '../../lib/api';

export const usageApi = {
  list: () => api.get('/usage-analyses'),
  get: (id) => api.get(`/usage-analyses/${id}`),
  create: (payload) => api.post('/usage-analyses', payload),
  update: (id, payload) => api.put(`/usage-analyses/${id}`, payload),
  remove: (id) => api.del(`/usage-analyses/${id}`),
  preview: (payload) => api.post('/usage-analyses/preview', payload),
};
